export function toSpaRoutes(routeMap) {
    return Object.keys(routeMap);
}
//# sourceMappingURL=toSpaRoutes.js.map